import React from "react";

export default function InsightPage() {
  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">🔍 Waterstream Insight</h1>
      <p className="mb-6 text-lg">Get Instant Insights from Documents, Spreadsheets & PDFs</p>
      <p className="mb-4">Waterstream Insight is your personal data analyst — powered by AI.</p>
      <ul className="list-disc list-inside mb-6">
        <li>📄 Upload Word docs</li>
        <li>📊 Drop in spreadsheets</li>
        <li>📘 Analyze PDFs</li>
        <li>➡️ Get instant insights, summaries, trends, and key takeaways in plain language</li>
      </ul>
      <p className="mb-4 font-semibold">Perfect for:</p>
      <ul className="list-disc list-inside mb-6">
        <li>Business reports</li>
        <li>Research files</li>
        <li>Financial data</li>
        <li>Contracts and legal docs</li>
      </ul>
      <p className="mb-4">With zero setup, zero fluff — just clarity.</p>
    </div>
  );
}
